import { create } from "zustand"
import { persist } from "zustand/middleware"

import localStorageNames from "@data/localStorageNames";


export const useStorePayment = create(persist((set, get) => ({
    paymentMethod: "normal_order",
    selectedPaymentMethod: null,    
    updatePayment: (newPayment) => {
        set({ paymentMethod: newPayment })
    },
    setSelectedPaymentMethod: (newSelectedPaymentMethod) => {
        set({ selectedPaymentMethod: newSelectedPaymentMethod })
    },
    getSelectedPaymentMethod: () => {
        return get().selectedPaymentMethod
    }
}),
    {
        name: localStorageNames.PAYMENT_METHOD
    }

))